var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3Navigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 36v4h-6v-4h6zM36 58h4v-6h-4v6zm4-40h-4v6h4v-6zm26 20a28 28 0 11-56 0 28 28 0 0156 0zm-4 0a24 24 0 10-48 0 24 24 0 0048 0zm-19.85 4L23.82 52.53l10.47-18.38 17.91-10L42.15 42zM40 39.86l-3.51-3.51-4.65 8.16L40 39.86zM24 36h-6v4h6v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Navigation.4a932e6f.svg";
export { SvgE3Navigation as ReactComponent };